const types = {
	//Get Template name
	GET_EMPLOYEE_EVALUATION_START: "GET_EMPLOYEE_EVALUATION_START",
	GET_EMPLOYEE_EVALUATION_SUCCESS: "GET_EMPLOYEE_EVALUATION_SUCCESS",
	GET_EMPLOYEE_EVALUATION_ERROR: "GET_EMPLOYEE_EVALUATION_ERROR",
	GET_EMPLOYEE_EVALUATION_RESET: "GET_EMPLOYEE_EVALUATION_RESET",

	//Create Template name
	CREATE_EMPLOYEE_EVALUATION_START: "CREATE_EMPLOYEE_EVALUATION_START",
	CREATE_EMPLOYEE_EVALUATION_SUCCESS: "CREATE_EMPLOYEE_EVALUATION_SUCCESS",
	CREATE_EMPLOYEE_EVALUATION_ERROR: "CREATE_EMPLOYEE_EVALUATION_ERROR",
	CREATE_EMPLOYEE_EVALUATION_RESET: "CREATE_EMPLOYEE_EVALUATION_RESET",

	//delete Template name
	DELETE_EMPLOYEE_EVALUATION_START: "DELETE_EMPLOYEE_EVALUATION_START",
	DELETE_EMPLOYEE_EVALUATION_SUCCESS: "DELETE_EMPLOYEE_EVALUATION_SUCCESS",
	DELETE_EMPLOYEE_EVALUATION_ERROR: "DELETE_EMPLOYEE_EVALUATION_ERROR",
	DELETE_EMPLOYEE_EVALUATION_RESET: "DELETE_EMPLOYEE_EVALUATION_RESET",

	//update Template name
	UPDATE_EMPLOYEE_EVALUATION_START: "UPDATE_EMPLOYEE_EVALUATION_START",
	UPDATE_EMPLOYEE_EVALUATION_SUCCESS: "UPDATE_EMPLOYEE_EVALUATION_SUCCESS",
	UPDATE_EMPLOYEE_EVALUATION_ERROR: "UPDATE_EMPLOYEE_EVALUATION_ERROR",
	UPDATE_EMPLOYEE_EVALUATION_RESET: "UPDATE_EMPLOYEE_EVALUATION_RESET",

	//single item  name
	SINGLE_EMPLOYEE_EVALUATION_START: "SINGLE_EMPLOYEE_EVALUATION_START",
	SINGLE_EMPLOYEE_EVALUATION_SUCCESS: "SINGLE_EMPLOYEE_EVALUATION_SUCCESS",
	SINGLE_EMPLOYEE_EVALUATION_ERROR: "SINGLE_EMPLOYEE_EVALUATION_ERROR",
	SINGLE_EMPLOYEE_EVALUATION_RESET: "SINGLE_EMPLOYEE_EVALUATION_RESET",
};

export default types;
